<template>
  <div>
    <click-to-edit
      v-model="scale.fact"
      type="date-picker"
      :disabled="disabled"
      placeholder=""
      @input="$emit('change', scale.fact)"
    ></click-to-edit>
  </div>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import ClickToEdit from "@/components/ClickToEdit";

export default {
  name: "linear-three-targets-card-fact-view",
  mixins: [dynamicScaleComponent],
  components: {ClickToEdit},

  props: {
    disabled:{type: Boolean, default: false}
  },

  data() {
    return {
      scale:{
        fact: null,
      },
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
}
</script>

<style>

</style>